// Copyright ©️ 2026 eVolve MEP, LLC

import { useEffect } from 'react';

import type { FacilityId } from '@evolvemep/api-ts';

import { WrappedSelect } from 'components/Mantine/TypeSafeSelect/WrappedSelect';
import { isNotNil } from 'helpers/isNotNil';
import { useEvolveGetWithLocalStorage } from 'hooks/useEvolveGetWithLocalStorage';
import { useLocalStorage } from 'hooks/useLocalStorage';

type Props = {
  facilityId: FacilityId;
};

export const FabItemsGroupBySelect = ({ facilityId }: Props) => {
  const [groupBy, setGroupBy] = useLocalStorage('FABRICATION_GROUP_BY', 'none');
  const { data: fabSettings } = useEvolveGetWithLocalStorage(`shop/fabrication/facility/${facilityId}/setting`);

  useEffect(() => {
    if (isNotNil(fabSettings) && !fabSettings.isCuttingEnabled && groupBy === 'cut-lists') {
      setGroupBy('none');
    }
  }, [fabSettings, groupBy, setGroupBy]);

  if (!fabSettings?.isCuttingEnabled) return null;

  return (
    <WrappedSelect
      label="Group By"
      inlineLabel
      value={groupBy}
      onChange={(v) => setGroupBy(v ?? 'none')}
      data={[
        { label: 'None', value: 'none' },
        { label: 'Cut List', value: 'cut-lists' },
      ]}
    />
  );
};
